export default __webpack_public_path__ + "static/wireframe1-a2e8c8b31029902fe7dbf3871970f41b.png";